import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import HowItWorks from "./pages/HowItWorks";
import Telehealth from "./pages/Telehealth";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Insurance from "./pages/Insurance";
import Privacy from "./pages/Privacy";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Consent from "./pages/Consent";
import Resources from "./pages/Resources";
import ResourceArticle from "./pages/ResourceArticle";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";

function App() {
 return (
 <div className="App">
 <HelmetProvider>
 <AuthProvider>
 <BrowserRouter>
 <Routes>
 <Route path="/" element={<Home />} />
 <Route path="/about" element={<About />} />
 <Route path="/services" element={<Services />} />
 <Route path="/how-it-works" element={<HowItWorks />} />
 <Route path="/telehealth" element={<Telehealth />} />
 <Route path="/contact" element={<Contact />} />
 <Route path="/faq" element={<FAQ />} />
 <Route path="/insurance" element={<Insurance />} />
 <Route path="/privacy" element={<Privacy />} />
 <Route path="/payment/success" element={<PaymentSuccess />} />
 <Route path="/payment/cancel" element={<PaymentCancel />} />
 <Route path="/consent" element={<Consent />} />
 <Route path="/resources" element={<Resources />} />
 <Route path="/resources/:slug" element={<ResourceArticle />} />
 <Route path="/admin/login" element={<AdminLogin />} />
 <Route path="/admin" element={<AdminDashboard />} />
 <Route path="*" element={<Home />} />
 </Routes>
 </BrowserRouter>
 </AuthProvider>
 </HelmetProvider>
 </div>
 );
}

export default App;
